import React from "react";
import { LegalLayout, S } from "@/components/LegalLayout";

export default function CookiePolicyPage() {
  return (
    <LegalLayout eyebrow="COOKIE POLICY" title="Cookie Policy" updated="February 2026">
      <p style={S.p}>ARGOV™ uses cookies and similar storage technologies only where strictly necessary to operate this website and the CRM console securely. We do not use third-party advertising, retargeting, or cross-site tracking technologies.</p>

      <h2 style={S.h2}>1. What is a cookie?</h2>
      <p style={S.p}>A cookie is a small text file placed on your device by a website. Similar technologies include browser localStorage, sessionStorage, and pixel tags. This policy uses &quot;cookies&quot; to refer to all such technologies collectively.</p>

      <h2 style={S.h2}>2. Cookies we use</h2>
      <div style={{ overflow: "auto", marginTop: 10 }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13.5 }}>
          <thead>
            <tr style={{ background: "#f8fafc" }}>
              <th style={cellHead}>Name</th>
              <th style={cellHead}>Type</th>
              <th style={cellHead}>Purpose</th>
              <th style={cellHead}>Retention</th>
            </tr>
          </thead>
          <tbody>
            <tr><td style={cell}>argov_token</td><td style={cell}>Local storage</td><td style={cell}>Stores your CRM authentication token so you remain signed in during your session.</td><td style={cell}>Up to 8 hours or until sign-out</td></tr>
            <tr><td style={cell}>argov_user</td><td style={cell}>Local storage</td><td style={cell}>Stores your basic profile (email, role, name) for CRM UI personalisation.</td><td style={cell}>Up to 8 hours or until sign-out</td></tr>
            <tr><td style={cell}>access_token</td><td style={cell}>HttpOnly cookie</td><td style={cell}>Defence-in-depth session token for the CRM. Set with Secure, HttpOnly, SameSite=Lax attributes.</td><td style={cell}>Up to 8 hours or until sign-out</td></tr>
          </tbody>
        </table>
      </div>
      <p style={{ ...S.p, marginTop: 16 }}>All three items above are <strong>strictly necessary</strong>. Under UAE PDPL and comparable regimes, strictly-necessary cookies do not require prior consent because the service cannot function without them.</p>

      <h2 style={S.h2}>3. Cookies we do not use</h2>
      <ul>
        <li style={S.li}>No advertising or profiling cookies.</li>
        <li style={S.li}>No cross-site tracking or fingerprinting.</li>
        <li style={S.li}>No third-party analytics on the marketing site.</li>
        <li style={S.li}>No social-network embeds that set third-party cookies.</li>
      </ul>

      <h2 style={S.h2}>4. Managing cookies</h2>
      <p style={S.p}>Most browsers allow you to block or delete cookies via their settings. Note that blocking the cookies listed above will prevent you from signing into the CRM console. Marketing pages (Landing, Frameworks, Compliance, Team, Enterprise, Contact) function without any cookies.</p>

      <h2 style={S.h2}>5. Contact</h2>
      <p style={S.p}>Questions about our cookie practices? Contact <a href="mailto:privacy@argov.ai" style={{ color: "#0891b2" }}>privacy@argov.ai</a>.</p>
    </LegalLayout>
  );
}

const cellHead = { textAlign: "left", padding: "10px 14px", borderBottom: "1px solid #e2eaf2", fontSize: 11, letterSpacing: "0.1em", color: "#94a3b8", textTransform: "uppercase", fontWeight: 600, fontFamily: "'DM Mono', monospace" };
const cell = { padding: "12px 14px", borderBottom: "1px solid #eef2f7", color: "#374151", verticalAlign: "top", lineHeight: 1.6 };
